import { render } from "./advice-category.vue?vue&type=template&id=632c7696&scoped=true"
import script from "./advice-category.vue?vue&type=script&lang=js"
export * from "./advice-category.vue?vue&type=script&lang=js"

import "./advice-category.vue?vue&type=style&index=0&id=632c7696&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632c7696"]])

export default __exports__